<script>
import truncate from 'lodash/truncate';

export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    limit: {
      type: Number,
      required: true,
    },
    isHtml: {
      required: false,
      default: false,
      type: Boolean
    },
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    limitedText() {
      return truncate(this.text, {
        length: this.limit,
        separator: /,? +/,
        omission: '',
      });
    },
  },
  methods: {
    hasSlot(slotName = 'default') {
      return !!this.$slots[slotName];
    },
  },
};
</script>
<!-- eslint-disable -->
<template>
  <div>
    <template v-if="!show">
      <div v-if="!isHtml"> {{ limitedText }} </div>
      <div v-else v-html="limitedText"></div>
    </template>
<template v-else>
      <div v-if="!isHtml" :class="$style.userFormattedText">{{ text }}</div>
      <div  v-else :class="$style.userFormattedText" v-html="text"></div>
      <slot></slot>
    </template>
<b-button v-if="text.length >= limit || hasSlot()" size="sm" variant="outline-primary" class="mt-2" block
  @click="show = !show">{{
      show ? 'Less' : 'Read more'
    }}</b-button>
</div>
</template>

<style lang="scss" module>
@import '@design';

.userFormattedText {
  white-space: pre-line;
}
</style>
